import QuestionPicker from './QuestionPicker';
export default QuestionPicker;



// WEBPACK FOOTER //
// ./src/components/QuestionPicker/index.js